/**
 * loại form gửi email cho khách hàng
 * 0: gửi thông báo hủy hóa đơn
 * 1: Gửi hóa đơn
 */
export default {
  Cancel: 0,
  Invoice: 1,
};
